export default "__VITE_ASSET__DRp$xcss__"